"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import { workScopeStatusOptions } from "../../constants/options"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
const baseFieldName = "home.drivewayRepair"

function HomeDrivewayRepairForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillDrivewayRepairOn = useWatch({ control, name: `${baseFieldName}.goodwillDrivewayRepairOn` })
    
    // Watch status field and claimed by field
    const drivewayRepair = useWatch({ control, name: `${baseFieldName}.drivewayRepair` })
    const drivewayClaimedBy = useWatch({ control, name: `${baseFieldName}.drivewayClaimedBy` })
    const goodwillDrivewayRepair = useWatch({ control, name: `${baseFieldName}.goodwillDrivewayRepair` })
    const goodwillDrivewayRepairClaimedBy = useWatch({
        control,
        name: `${baseFieldName}.goodwillDrivewayRepairClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: drivewayRepair,
        claimedBy: drivewayClaimedBy,
        claimedByFieldPath: `${baseFieldName}.drivewayClaimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillDrivewayRepair,
        claimedBy: goodwillDrivewayRepairClaimedBy,
        claimedByFieldPath: `${baseFieldName}.goodwillDrivewayRepairClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillDrivewayRepairOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Driveway Repair"
            wrapperClassName="xl:grid-cols-2"
        >
            <FormSelectInput
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Driveway Repair" toggleName={`${baseFieldName}.goodwillDrivewayRepairOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${baseFieldName}.drivewayRepair`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{
                    label: "Driveway Claimed By",
                }}
                options={claimedByOptions}
                name={`${baseFieldName}.drivewayClaimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillDrivewayRepairOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Driveway Repair Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${baseFieldName}.goodwillDrivewayRepair`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Driveway Repair Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${baseFieldName}.goodwillDrivewayRepairClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Driveway Repair Description",
                    wrapperClassName: "xl:col-span-2"
                }}
                rows={3}
                placeholder="Describe the driveway repair work needed"
                name={`${baseFieldName}.drivewayRepairDescription`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeDrivewayRepairForm

